import React from 'react';
import { Calendar, FileText, Send, Upload, Home, Trophy, CheckCircle2, Clock } from 'lucide-react';
import { MetricTile } from './MetricTile';
import { motion } from 'framer-motion';
import { LoanStage } from '../data/loans';
interface TodayScorecardProps {
  onTileClick?: (stage: LoanStage) => void;
}
export function TodayScorecard({
  onTileClick
}: TodayScorecardProps = {}) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay: 0.1
  }} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden flex flex-col h-full" data-id="element-395">
      <div className="bg-[#0a1e5e] px-4 py-3 flex items-center justify-between text-white" data-id="element-396">
        <div className="flex items-center gap-2" data-id="element-397">
          <Calendar className="w-5 h-5" data-id="element-398" />
          <h2 className="font-bold tracking-wide" data-id="element-399">TODAY'S SCORECARD</h2>
        </div>
        <span className="text-sm font-medium text-blue-200" data-id="element-400">May 14, 2025</span>
      </div>

      <div className="p-5 flex-1 flex flex-col" data-id="element-401">
        {/* Top Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-4 sm:divide-x divide-gray-200 gap-y-4 mb-6" data-id="element-402">
          <div className="text-center px-2 min-w-0" data-id="element-403">
            <p className="text-[10px] font-bold text-gray-500 uppercase mb-1 leading-tight" data-id="element-404">
              Today's Target
            </p>
            <p className="text-3xl font-extrabold text-[#0a1e5e] leading-none" data-id="element-405">
              420
            </p>
            <p className="text-[10px] font-bold text-gray-400 uppercase mt-1" data-id="element-406">
              Points
            </p>
          </div>
          <div className="text-center px-2 min-w-0" data-id="element-407">
            <p className="text-[10px] font-bold text-gray-500 uppercase mb-1 leading-tight" data-id="element-408">
              Remaining Today
            </p>
            <p className="text-3xl font-extrabold text-green-600 leading-none" data-id="element-409">
              0
            </p>
            <p className="text-[10px] font-bold text-gray-400 uppercase mt-1" data-id="element-410">
              Points
            </p>
          </div>
          <div className="text-center px-2 min-w-0" data-id="element-411">
            <p className="text-[10px] font-bold text-gray-500 uppercase mb-1 leading-tight" data-id="element-412">
              Days Left
            </p>
            <p className="text-3xl font-extrabold text-[#0a1e5e] leading-none" data-id="element-413">
              17
            </p>
            <p className="text-[10px] font-bold text-gray-400 uppercase mt-1" data-id="element-414">
              In Month
            </p>
          </div>
          <div className="text-center px-2 min-w-0" data-id="element-415">
            <p className="text-[10px] font-bold text-gray-500 uppercase mb-1 leading-tight" data-id="element-416">
              Daily Target
            </p>
            <p className="text-3xl font-extrabold text-[#0a1e5e] leading-none" data-id="element-417">
              420
            </p>
            <p className="text-[10px] font-bold text-gray-400 uppercase mt-1" data-id="element-418">
              Pts / Day
            </p>
          </div>
        </div>

        <h3 className="text-sm font-bold text-blue-600 uppercase tracking-wider mb-4" data-id="element-419">
          Today's Performance
        </h3>

        {/* Metric Tiles */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6" data-id="element-420">
          <MetricTile title="Credit Pulls" points={750} count={1} countLabel="Pulls" icon={FileText} colorClass="text-blue-700" bgClass="bg-blue-100" onClick={onTileClick ? () => onTileClick('credit_pull') : undefined} data-id="element-421" />
          <MetricTile title="Doc Outs" points={500} count={1} countLabel="Doc Out" icon={Send} colorClass="text-green-600" bgClass="bg-green-100" onClick={onTileClick ? () => onTileClick('doc_out') : undefined} data-id="element-422" />
          <MetricTile title="Submissions" points={500} count={1} countLabel="Submission" icon={Upload} colorClass="text-purple-600" bgClass="bg-purple-100" onClick={onTileClick ? () => onTileClick('submission') : undefined} data-id="element-423" />
          <MetricTile title="Closings" points={250} count={0} countLabel="Closings" icon={Home} colorClass="text-orange-500" bgClass="bg-orange-100" onClick={onTileClick ? () => onTileClick('closing') : undefined} data-id="element-424" />
        </div>

        {/* Success Banner */}
        <div className="grid sm:grid-cols-2 gap-3 mb-4" data-id="element-425">
          <div className="bg-white border border-gray-200 rounded-xl p-4 flex items-center gap-3 min-w-0" data-id="element-426">
            <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center shrink-0" data-id="element-427">
              <Trophy className="w-6 h-6 text-white" data-id="element-428" />
            </div>
            <div className="min-w-0" data-id="element-429">
              <p className="text-xs font-bold text-gray-500 uppercase leading-tight" data-id="element-430">
                Total Points Today
              </p>
              <div className="flex items-baseline gap-1 flex-wrap" data-id="element-431">
                <span className="text-3xl font-extrabold text-green-600 leading-none" data-id="element-432">
                  2,000
                </span>
                <span className="text-xs font-bold text-gray-500" data-id="element-433">POINTS</span>
              </div>
            </div>
          </div>
          <div className="bg-green-50 border border-green-200 rounded-xl p-4 flex items-center gap-3 min-w-0" data-id="element-434">
            <div className="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center shrink-0" data-id="element-435">
              <CheckCircle2 className="w-6 h-6 text-white" data-id="element-436" />
            </div>
            <p className="text-sm font-bold text-green-700 uppercase leading-tight" data-id="element-437">
              You Beat Today's Goal!
            </p>
          </div>
        </div>

        {/* Speed Bonus */}
        <div className="bg-orange-50 border border-orange-200 rounded-xl p-4 flex items-center justify-between gap-3 mb-6" data-id="element-438">
          <div className="flex items-center gap-3 min-w-0 flex-1" data-id="element-439">
            <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center shrink-0" data-id="element-440">
              <Clock className="w-5 h-5 text-white" data-id="element-441" />
            </div>
            <div className="min-w-0" data-id="element-442">
              <p className="text-sm font-bold text-[#0a1e5e] uppercase leading-tight" data-id="element-443">
                Speed Bonus
              </p>
              <p className="text-xs text-gray-600 leading-tight mt-0.5" data-id="element-444">
                Close a loan within 14 days of credit pull
              </p>
            </div>
          </div>
          <div className="text-right shrink-0" data-id="element-445">
            <div className="flex items-baseline gap-1 justify-end" data-id="element-446">
              <span className="text-2xl font-extrabold text-orange-500 leading-none" data-id="element-447">
                0
              </span>
              <span className="text-xs font-bold text-gray-500" data-id="element-448">PTS</span>
            </div>
            <p className="text-[10px] font-bold text-gray-500 uppercase mt-1" data-id="element-449">
              Today
            </p>
          </div>
        </div>

        {/* Footer Stats */}
        <div className="mt-auto grid grid-cols-2 divide-x divide-gray-200 pt-4 border-t border-gray-100" data-id="element-450">
          <div className="text-center" data-id="element-451">
            <p className="text-[10px] font-bold text-gray-500 uppercase mb-1" data-id="element-452">
              Goal Remaining Today
            </p>
            <div className="flex items-baseline justify-center gap-1" data-id="element-453">
              <span className="text-2xl font-extrabold text-green-600" data-id="element-454">0</span>
              <span className="text-xs font-bold text-gray-400" data-id="element-455">POINTS</span>
            </div>
          </div>
          <div className="text-center" data-id="element-456">
            <p className="text-[10px] font-bold text-gray-500 uppercase mb-1" data-id="element-457">
              % Of Goal Remaining
            </p>
            <span className="text-2xl font-extrabold text-green-600" data-id="element-458">0%</span>
          </div>
        </div>
      </div>
    </motion.div>;
}